export default __webpack_public_path__ + "static/player_stats_1-8bd0d896cd05b60c723a4ceeffb6af6e.mp4";